import React from 'react';
import CardSlotV2 from '@intelligence/components/CardSlotV2';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
// import ExportTable from '@intelligence/components/ExportTable';
// import { TopchartPageId } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import CompareVisualis from '@intelligence/pages/Compare/PcConsoleGamesBeta/components/VisualList/VisualCard/CompareVisualis';

import './index.scss';

type Props = {
  // 时间粒度展示时间文案
  dateType: string;
  // 是否 alignToRelease
  isAlignToRelease?: boolean;
  loading?: boolean;
  // 当前折线图色盘
  colors?: string[];
  // 图表数据
  lineData: any;
  // metric title 需展示的对应文案中英配置 ID
  metricTextKey: string;
  // steam pcu acu 指标特殊指定
  icon?: string;
  // 数据源展示 metric title 对应图标
  dataSource: string;
  // 是否为百分比指标，处理数据及图表相关展示
  isPercentage: boolean;
  // 是否为监听触发懒加载数据的哨兵元素
  isSentinel?: boolean;
};

// 下载组件属性
// const entityType = 'combine';

function VisualCard({
  dateType,
  loading,
  colors,
  lineData,
  metricTextKey,
  icon,
  dataSource,
  isPercentage,
  isAlignToRelease,
  isSentinel,
}: Props) {
  const { formatMessage } = useIntlExtend();

  const metricText = formatMessage({ id: metricTextKey });
  // 当前卡片 title 展示
  const getTitle = () => {
    const currentIcon = getDataSourceIcon(icon || dataSource);
    return (
      <div className="dbi_compare_visual_card_title">
        {currentIcon && <img src={currentIcon} alt="" />}
        <span>{metricText}</span>
      </div>
    );
  };

  // // 下载相关
  // const getDownloadFetchParams = () => {
  //   // const paramsTmp: {
  //   //   [key: string]: any;
  //   // } = {
  //   //   ...fetchParams,
  //   //   segment: 'All',
  //   //   subSegment: 'allMetrics',
  //   //   unified_id: gameId,
  //   //   unified_ids: [gameId],
  //   //   currentMetric: 'allMetrics',
  //   //   isCountriesPage: false,
  //   // };
  //   // return paramsTmp;
  //   return {
  //     unified_ids: ['c00003330'],
  //     entity_type: 'combine',
  //     region_type: 'market',
  //     regions: ['global'],
  //     date_type: 'monthly',
  //     start_date: '2024-04-01',
  //     end_date: '2024-09-30',
  //     device: ['PC', 'PlayStation', 'Xbox', 'Nintendo'],
  //     source_metrics: {
  //       mscience: ['digitalRevenue'],
  //       npd: ['revenue'],
  //       vginsights: ['est_revenue', 'est_cumulative_revenue', 'est_units', 'est_cumulative_units'],
  //     },
  //     data_method: 'date',
  //     segment_list: ['All'],
  //     segment: 'All',
  //     subSegment: 'allMetrics',
  //     unified_id: 'c00003330',
  //     currentMetric: 'allMetrics',
  //     isCountriesPage: false,
  //   };
  // };

  // // 下载组件
  // const exportTableCom = (
  //   <div className="dbi_compare_visual_card_download_icon">
  //     <ExportTable
  //       buttonType="icon"
  //       entityType={entityType}
  //       buttonClassName={'trends-table-download-icon'}
  //       tableParams={getDownloadFetchParams()}
  //       businessType={`${entityType}-stats-countries`}
  //       isDisableDownload={loading}
  //       isShowMaxDownloadRowsTips={false}
  //       downloadModalSize={820}
  //       isDisableDataAmount={true}
  //       newStyleFileName={`${'compares'}${'_Stats'}`}
  //       pageId={TopchartPageId.PCConsoleMetricsTable}
  //     />
  //   </div>
  // );

  return (
    <div
      className="dbi_compare_visual_card_wrap"
      id={isSentinel ? 'dbi_compare_visual_card_sentinel' : ''}
    >
      <CardSlotV2
        className="dbi_compare_visual_card"
        title={!loading && getTitle()}
        iconList={[]}
        // 下载本期不做，图标隐藏
        // rightDom={lineData?.length && exportTableCom}
      >
        <div className="dbi_compare_visual_chart_container">
          <CompareVisualis
            colors={colors}
            chartLoading={loading}
            dateType={dateType}
            isAlignToRelease={isAlignToRelease}
            lineData={lineData}
            isPercentage={isPercentage}
            metricText={metricText}
          />
        </div>
      </CardSlotV2>
    </div>
  );
}

export default React.memo(VisualCard);
